import { crudSelectors } from "~/hocs";

export const getRecord = (state, modelName, editName) => {
    const gridData = crudSelectors.getGridData(state);
    if (gridData[modelName]) {
        return gridData[modelName][editName] ? gridData[modelName][editName] : null;
    }
};
